/** Redux */
import * as types from "./types";

/** Types */
import type { IAppDispatch } from "../configureStore";

import type {
  IAnyObject
} from "../../types";
import { createAction } from "@reduxjs/toolkit";

const sendMessage = (dispatch: IAppDispatch) => {
  return (payload: IAnyObject) => {
    dispatch({ payload, type: types.SOCKET_SEND_MESSAGE });
  };
};

export function getBankLinkTokenAction() {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "POST",
      path: "property/bank/token",
      // user: {
      //   resource_name: resource_name
      // },
      type: types.GET_BANK_LINK_TOKEN,
    });
  };
}

export function exchangeBankPublicTokenAction(public_token: string) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/setAccessToken",
      public_token: public_token,
      // user: {
      //   resource_name: data.resource_name
      // },
      type: types.ADD_BANK_SUCCESS,
    });
  };
}

export function getConectedBankAction() {
  return (dispatch: IAppDispatch, getState: any) => {
    sendMessage(dispatch)({
      action: "property",
      method: "GET",
      path: "property/bank/getConnectedBankAccounts",
      // user: {
      //   resource_name: resource_name
      // },
      type: types.GET_CONNECTED_BANK_SUCCESS,
    });
  };
}

export function attachBankToPropertyAction(data: { bank_resource_name: string, resource_name: string }) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "POST",
      path: "property/bank/attachBankToProperty",
      bank_account: {
        resource_name: data.bank_resource_name
      },
      property: {
        resource_name: data.resource_name
      },
      type: types.ATTACH_BANK_TO_PROPERTY,
    });
  };
}

export function deleteAccountAction(data: { item_id: string, resource_name: string }) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "DELETE",
      path: "property/bank/deleteBankAccount",
      item_id: data.item_id,
      type: types.DELETE_PLAID_ITEM_SUCCESS,
    });
  };
}

export function detachBankFromProperty(data: { bank_resource_name: string, resource_name: string }) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/detachBankFromProperty",
      bank_account: {
        resource_name: data.bank_resource_name
      },
      property: {
        resource_name: data.resource_name
      },
      type: types.DETACH_BANK_FROM_PROPERTY_SUCCESS,
    });
  };
}

export function renameBankAccount(data: { resource_name: string, new_name: string }) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/renameBankAccount",
      bank_account: {
        resource_name: data.resource_name
      },
      new_name: data.new_name,
      type: types.RENAME_BANK_ACCOUNT_SUCCESS,
    });
  };
}

export function syncTransactions(item_id: string, resource_name: string) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/syncTransactions",
      item_id,
      property: {
        resource_name: resource_name
      },
      type: types.FETCH_TRANSACTIONS_SUCCESS,
    });
  };
}

export function getTransactionsAction(params: any) {
  return (dispatch: IAppDispatch) => {
    // console.log("first");
    sendMessage(dispatch)({
      action: "property",
      method: "GET",
      path: "property/bank/getAllUserTransactions",
      limit: 50,
      lastKey: params?.lastKey ? params?.lastKey : "",
      startDate: params?.startDate ? params?.startDate : "",
      endDate: params?.endDate ? params?.endDate : "",
      search: params?.search ? params?.search : "",
      type: types.GET_BANK_TRANSACTIONS_SUCCESS,
    });
  };
}

export function getFilterTransactionsAction(params: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "GET",
      path: "property/bank/getAllUserTransactions",
      limit: 20,
      lastKey: params?.lastKey ? params?.lastKey : "",
      startDate: params?.startDate ? params?.startDate : "",
      endDate: params?.endDate ? params?.endDate : "",
      search: params?.search ? params?.search : "",
      type: types.GET_BANK_FILTER_TRANSACTIONS_SUCCESS,
    });
  };
}

export function updateTransactionCategory(data: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/updateTransactionCategory",
      bank_transaction: {
        resource_name: data.resource_name
      },
      category: data.category,
      type: types.UPDATE_TRANSACTION_CATEGORY_SUCCESS,
    });
  };
}

export function linkTransactionToProperty(data: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/linkTransactionToProperty",
      bank_transaction: {
        resource_name: data.resource_name
      },
      property: {
        resource_name: data.property_resource_name
      },
      type: types.LINK_TRANSACTION_PROPERTY_SUCCESS,
    });
  };
}

export function checkDuplication(data: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "GET",
      path: "property/bank/checkDuplication",
      bank_transaction: {
        resource_name: data?.resource_name
      },
      property: {
        resource_name: data?.property_resource_name
      },
      category: data?.category,
      type: types.CHECK_DUPLICATION,
    });
  };
}

export function checkDuplicationForMultipleTransactions(data: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "GET",
      path: "property/bank/checkDuplicationForMultipleTransactions",
      bank_transactions: data.bank_transactions,
      property: {
        resource_name: data?.property_resource_name
      },
      category: data?.category,
      type: types.CHECK_MULTIPLE_DUPLICATION,
    });
  };
}

export function updateTransactionNotes(data: any) {
  return (dispatch: IAppDispatch) => {
    sendMessage(dispatch)({
      action: "property",
      method: "PUT",
      path: "property/bank/updateTransactionNotes",
      bank_transaction: {
        resource_name: data.resource_name
      },
      notes: data.notes,
      type: types.UPDATE_TRANSACTION_NOTES_SUCCESS,
    });
  };
}


export const linkTransactionPropertyCancel = createAction(types.LINK_TRANSACTION_PROPERTY_CANCEL);
